import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './Deals.css';

const Deals = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const featuredArticles = [
    {
      id: 1,
      category: "M&A",
      title: "Tech Giant Announces $15B Acquisition",
      subtitle: "Major tech company closes record deal this quarter",
      time: "2 hours ago",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=675&fit=crop",
      slug: "tech-giant-acquisition",
    },
    {
      id: 2,
      category: "PRIVATE EQUITY",
      title: "PE Firm Raises $20B Fund",
      subtitle: "Largest fund raise to date in tech buyouts",
      time: "4 hours ago",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=675&fit=crop",
      slug: "pe-firm-fundraise",
    },
    {
      id: 3,
      category: "IPO",
      title: "Fintech Unicorn Files for $8B IPO",
      subtitle: "Digital payments leader targets public market debut in Q2",
      time: "6 hours ago",
      image:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=1200&h=675&fit=crop",
      slug: "fintech-unicorn-ipo",
    },
    {
      id: 4,
      category: "MERGER",
      title: "Pharmaceutical Giants Agree to $92B Merger",
      subtitle: "Two drugmakers combine to create world's third-largest pharma company",
      time: "8 hours ago",
      image:
        "https://images.unsplash.com/photo-1585435557343-3b092031a831?w=1200&h=675&fit=crop",
      slug: "pharma-merger-deal",
    },
  ];

  const dealsListLeft = [
    {
      id: 1,
      title: "Aurionpro Secures IDBI Bank Data Center Contract",
      time: "2 Feb 2026 12:46 PM",
      image:
        "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=200&h=200&fit=crop&q=80",
      slug: "/ai-revolution-transforms-industries",
    },
    {
      id: 2,
      title: "Lupin Partners With TB Alliance on Telacebec",
      time: "2 Feb 2026 10:10 AM",
      image:
        "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=200&h=200&fit=crop&q=80",
      slug: "lupin-tb-alliance",
    },
    {
      id: 3,
      title: "Godrej Properties Achieves ₹2,000 Cr Sales at World Launch",
      time: "2 Feb 2026 10:03 AM",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=300&h=300&fit=crop",
      slug: "godrej-properties-sales",
    },
    {
      id: 4,
      title:
        "Union Budget 2026: Government Amps Up Investment in IREDA to ₹40,064 Crore",
      time: "2 Feb 2026 2:00 PM",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&h=200&fit=crop&q=80",
      slug: "union-budget-ireda",
    },
    {
      id: 5,
      title: "Govt Trims UPI Incentive Allocation for FY27",
      time: "1 Feb 2026 1:55 PM",
      image:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=200&h=200&fit=crop&q=80",
      slug: "upi-incentive-cut",
    },
    {
      id: 11,
      title: "Fintech Company Secures Banking License in Major Milestone",
      time: "1 Feb 2026 11:20 AM",
      image:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=200&h=200&fit=crop&q=80",
      slug: "fintech-banking-license",
    },
    {
      id: 12,
      title: "Healthcare Provider Announces $1.8 Billion Expansion Plan",
      time: "1 Feb 2026 9:45 AM",
      image:
        "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=200&h=200&fit=crop&q=80",
      slug: "healthcare-expansion",
    },
    {
      id: 13,
      title: "Real Estate Developer Closes $900 Million Land Acquisition",
      time: "31 Jan 2026 5:30 PM",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=200&h=200&fit=crop&q=80",
      slug: "real-estate-land-deal",
    },
    {
      id: 14,
      title: "Infrastructure Fund Commits $2.5 Billion to Metro Project",
      time: "31 Jan 2026 2:15 PM",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=200&h=200&fit=crop&q=80",
      slug: "infrastructure-metro-investment",
    },
    {
      id: 15,
      title: "Telecom Giant Acquires 5G Spectrum Rights for $4.2 Billion",
      time: "31 Jan 2026 10:00 AM",
      image:
        "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=200&h=200&fit=crop&q=80",
      slug: "telecom-5g-spectrum",
    },
  ];

  const dealsListRight = [
    {
      id: 6,
      title: "Tech Startup Raises $250 Million in Series C Funding",
      time: "3 Feb 2026 9:30 AM",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&h=200&fit=crop&q=80",
      slug: "tech-startup-series-c",
    },
    {
      id: 7,
      title: "Pharmaceutical Giant Acquires Biotech Firm for $5.2 Billion",
      time: "3 Feb 2026 8:15 AM",
      image:
        "https://images.unsplash.com/photo-1585435557343-3b092031a831?w=200&h=200&fit=crop&q=80",
      slug: "pharma-biotech-acquisition",
    },
    {
      id: 8,
      title: "Renewable Energy Company Completes IPO at $8B Valuation",
      time: "2 Feb 2026 4:20 PM",
      image:
        "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=200&h=200&fit=crop&q=80",
      slug: "renewable-energy-ipo",
    },
    {
      id: 9,
      title: "Private Equity Firm Exits Portfolio Company in $3.8B Deal",
      time: "2 Feb 2026 11:45 AM",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=200&h=200&fit=crop&q=80",
      slug: "pe-firm-exit",
    },
    {
      id: 10,
      title: "Automotive Manufacturer Announces Joint Venture in Asia",
      time: "1 Feb 2026 3:30 PM",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=200&h=200&fit=crop&q=80",
      slug: "automotive-joint-venture",
    },
    {
      id: 16,
      title: "E-commerce Platform Completes Merger with Logistics Company",
      time: "1 Feb 2026 8:00 AM",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&h=200&fit=crop&q=80",
      slug: "ecommerce-logistics-merger",
    },
    {
      id: 17,
      title: "Semiconductor Manufacturer Invests $6 Billion in New Facility",
      time: "31 Jan 2026 4:45 PM",
      image:
        "https://images.unsplash.com/photo-1518770660439-4636190af475?w=200&h=200&fit=crop&q=80",
      slug: "semiconductor-facility-investment",
    },
    {
      id: 18,
      title: "Media Conglomerate Acquires Streaming Service for $3.1 Billion",
      time: "31 Jan 2026 1:30 PM",
      image:
        "https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=200&h=200&fit=crop&q=80",
      slug: "media-streaming-acquisition",
    },
    {
      id: 19,
      title: "Defense Contractor Wins $7.8 Billion Government Contract",
      time: "31 Jan 2026 11:15 AM",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=200&h=200&fit=crop&q=80",
      slug: "defense-government-contract",
    },
    {
      id: 20,
      title: "Food & Beverage Company Announces Strategic Divestiture",
      time: "30 Jan 2026 3:00 PM",
      image:
        "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=200&h=200&fit=crop&q=80",
      slug: "food-beverage-divestiture",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Deals & M&A News | Redbox Global</title>
      </Helmet>

      <div className="deals-page">
        <div className="container">
          {/* Breadcrumb */}
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/markets">Markets</Link>
            <span>/</span>
            <span className="current">Deals</span>
          </nav>

          {/* Header */}
          <header className="page-header">
            <h1 className="page-title">Deals</h1>
            <p className="page-description">
              Breaking news on mergers, acquisitions, IPOs, and corporate
              transactions
            </p>
          </header>

          {/* Featured Swiper Slider */}
          <section className="featured-section">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              loop
              className="deals-swiper"
            >
              {featuredArticles.map((article) => (
                <SwiperSlide key={article.id}>
                  <article className="featured-article">
                    <Link to={`/article/${article.slug}`}>
                      <div className="featured-image">
                        <img src={article.image} alt={article.title} />
                        <span className="featured-category">{article.category}</span>
                      </div>
                    </Link>
                    <div className="featured-content">
                      <h2 className="featured-title">
                        <Link to={`/article/${article.slug}`}>{article.title}</Link>
                      </h2>
                      <p className="featured-subtitle">{article.subtitle}</p>
                      <div className="article-meta">{article.time}</div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {/* 📌 TWO-COLUMN BLOOMBERG-STYLE LIST VIEW */}
          <section className="bloomberg-two-columns">
            {/* Left Column */}
            <div className="bloomberg-column">
              {dealsListLeft.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>

            {/* Right Column */}
            <div className="bloomberg-column">
              {dealsListRight.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Deals;








          
          
